import React, { createContext, useState, useCallback } from 'react';
import { createContextHook } from '../contextUtils';
import _ from 'lodash';

// FilterContext manages filter states and selections
const FilterContext = createContext();

export function FilterProvider({ children }) {
  // Currently selected filter combination
  const [selectedFacet, setSelectedFacet] = useState(null); 
  // Previously selected filter for comparison/undo
  const [previousSelectedFacet, setPreviousSelectedFacet] = useState(null); 
  // All available filter combinations
  const [allFacets, setAllFacets] = useState(null); 
  // Current area type selection (All/Rural/Urban)
  const [areaType, setAreaType] = useState("all"); 
  // Current filter information display
  const [filterInfo, setFilterInfo] = useState([]); 
  // Available All/Rural/Urban filter options
  const [truFilter, setTruFilter] = useState(null); 
  // Additional filter options
  const [otherFilters, setOtherFilters] = useState(null); 
  // Notes/descriptions for current filter selection
  const [facetNote, setFacetNote] = useState(null);

  // Updates the filter information display based on current selections
  const updateFilterInfo = useCallback(() => {
    // Return early if no filter is selected
    if (!selectedFacet) return;
    
    const currentFacet = _.cloneDeep(selectedFacet.facet); // Create a deep copy of the selected facet to avoid mutation
    const temp = [`Area: ${areaType.charAt(0).toUpperCase() + areaType.slice(1)}`]; // Initialize array with area type (All/Rural/Urban)
    
    // Add each filter key-value pair to the array
    // Example: "Category: Agriculture", "Year: 2020"
    Object.keys(currentFacet).forEach(key => {
      temp.push(`${key}: ${currentFacet[key]}`);
    });
    
    // Update the filter info display with the new array
    setFilterInfo(temp);
  }, [selectedFacet, areaType]);

  const value = {
    selectedFacet, setSelectedFacet,
    previousSelectedFacet, setPreviousSelectedFacet,
    allFacets, setAllFacets,
    areaType, setAreaType,
    filterInfo, setFilterInfo,
    truFilter, setTruFilter,
    otherFilters, setOtherFilters,
    facetNote, setFacetNote,
    updateFilterInfo
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
}

export const useFilter = createContextHook(FilterContext, 'useFilter');